import { Icon } from "@storeblocks/icon";
import { CustomerDiscounts } from "Components/CurrentPriceMessage/CustomerDiscounts";
import { CurrentPriceMessageContainer } from "Components/CurrentPriceMessage/styles";
import { StickyWrapper } from "Components/StickyWrapper/StickyWrapper";
import { TextManager } from "Components/TextContext";
import { ProductBackendName } from "Features/CheckPrice/Products/productTypes";
import React, { ReactElement } from "react";

interface Props {
  sticky: boolean;
  productBackendName: ProductBackendName;
}

export const CurrentPriceMessageWithUnselectedCoverageElement = ({
  sticky,
  productBackendName,
}: Props): ReactElement => {
  const { getText } = TextManager;
  return (
    <>
      {sticky ? (
        <StickyWrapper withMarginBottom={false}>
          <CurrentPriceMessageContainer className="current-price-message">
            <Icon name="hand-discount" size={48} />
            <span>
              {getText("common.price.currentpricemessage.nocoverageselected")}
            </span>
          </CurrentPriceMessageContainer>
        </StickyWrapper>
      ) : (
        <CurrentPriceMessageContainer className="current-price-message">
          <Icon name="hand-discount" size={48} />
          <span>
            {getText("common.price.currentpricemessage.nocoverageselected")}
          </span>
        </CurrentPriceMessageContainer>
      )}
      <CustomerDiscounts productBackendName={productBackendName} prices={[]} />
    </>
  );
};
